import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    askSelfie: {
      description:
        'This step allows us to make sure that you are the one who requested the closure of your account.',
      title: 'We will ask you for a selfie',
    },
    bodyCloseSecurely:
      'Before closing your bank account, we ask you to take the following actions for more security.',
    bodyIdentityCheck:
      'This step allows us to make sure that you are the one who requested the closure of your account.',
    cutCard: {
      description: 'We need to make sure your card is unusable.',
      title: 'Please cut up your Shine card',
    },
    cutCards: {
      description: 'We need to make sure your cards are unusable.',
      title: 'Please cut up your Shine cards',
    },
    next: 'Verify my identity',
    takeId: {
      description: 'We will ask you for a photo of your ID card or passport.',
      title: 'Have your identity card ready',
    },
    titleCloseSecurely: 'Close my Shine account',
    titleIdentityCheck: 'We need to verify your identity',
    verifyIdentity: {
      description: 'To make sure no one is pretending to be you.',
      title: 'Verification of your identity',
    },
  },
  fr: {
    askSelfie: {
      description:
        'Cette étape nous permet de vérifier que personne ne se fait passer pour vous.',
      title: 'Nous vous demanderons un selfie',
    },
    bodyCloseSecurely:
      'Avant de clôturer votre compte bancaire, nous vous demandons d’effectuer les actions suivantes pour plus de sécurité.',
    bodyIdentityCheck:
      'Cette étape nous permet de nous assurer que vous êtes bien à l’origine de la demande de fermeture de votre compte.',
    cutCard: {
      description: 'Pour s’assurer que votre carte est inutilisable.',
      title: 'Découper votre carte bancaire Shine',
    },
    cutCards: {
      description: 'Pour s’assurer que vos cartes sont inutilisables.',
      title: 'Découper vos cartes bancaires Shine',
    },
    next: 'Vérifier mon identité',
    takeId: {
      description:
        'Nous allons vous demander une photo de votre carte d’identité ou de votre passeport.',
      title: 'Munissez-vous d’une pièce d’identité',
    },
    titleCloseSecurely: 'Clôturer votre compte en toute sécurité',
    titleIdentityCheck: 'Nous devons vérifier votre identité',
    verifyIdentity: {
      description: 'Pour s’assurer que personne ne se fait passer pour vous.',
      title: 'Vérification de votre identité',
    },
  },
});

export default locales;
